import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingHeaderSeo } from '../../components/NewbuildingHeaderSeo';
import { getNewbuildingHeaderSeo } from '../../selectors/newbuildingHeader';

export const NewbuildingHeaderSeoContainer: React.FC = () => {
  const { title, url, description } = useSelector(getNewbuildingHeaderSeo);

  return <NewbuildingHeaderSeo title={title} url={url} description={description} />;
};
